import Typography from "@/components/shared/Typography"
import { ALPHABET } from "@/conf"
import Image from "next/image"
import { AnswerType } from "swagger/models"
import { twMerge } from "tailwind-merge"

interface AnswerItemProps {
  text: string
  imageSrc: string
  type: AnswerType
  index: number
  onClick?: () => void
  isSelected: boolean
  answerState: "failure" | "success" | ""
}

const AnswerItem = ({ type, index, imageSrc, text, onClick, isSelected, answerState }: AnswerItemProps) => {
  return (
    <div
      className={twMerge(
        "relative rounded-2xl bg-stateBonus-200",
        type === AnswerType.TEXT && "flex gap-4 p-6",
        type === AnswerType.IMAGE && "p-4",
        isSelected && "bg-stateBonus-50 text-primary-500",
        isSelected && answerState === "success" && "bg-success-500",
        isSelected && answerState === "failure" && "bg-error-300",
        answerState === "" && "cursor-pointer",
      )}
      onClick={onClick}
    >
      <div
        className={twMerge(
          "flex h-6 w-6 items-center justify-center rounded-full bg-stateBonus-100 text-primary-50",
          isSelected && "bg-primary-50 text-primary-500",
          type === AnswerType.IMAGE && "absolute left-2 top-2",
          isSelected && answerState === "success" && "bg-success-700 text-primary-50",
          isSelected && answerState === "failure" && "bg-error-700 text-primary-50",
        )}
      >
        <Typography type="btn">{ALPHABET[index]}</Typography>
      </div>
      {type === AnswerType.IMAGE && <Image src={imageSrc} width={500} height={376} alt="" />}
      {type === AnswerType.TEXT && (
        <Typography
          type="l"
          className={twMerge(
            isSelected && answerState === "success" && "text-success-700",
            isSelected && answerState === "failure" && "text-error-700",
          )}
        >
          {text}
        </Typography>
      )}
    </div>
  )
}

export default AnswerItem
